import { addMessages } from '@hana/i18n';

// Khoá của thẻ giá khổ iPad / điện thoại (P2PPadCard.tsx, board Mint-P2P-iPad · Phone, bước kết quả). Tiền tố `pd.`.
addMessages('vi', {
  'pd.pick': 'Chọn {v} vào báo giá',
  'pd.pickTip': 'Đưa dòng này vào báo giá',
  'pd.open': 'Mở chi tiết {v}: local charge, lịch tàu, free time, lịch sử giá, báo giá dòng này',
  'pd.openTip': 'Chi tiết · local charge, lịch tàu, free time, lịch sử giá',
  'pd.carSvc': 'Hãng · Dịch vụ',
  'pd.svcUnmapped': 'service chưa map',
  'pd.freqUnmapped': 'tần suất chưa map',
  'pd.weekly': 'hàng tuần · ETD {d}',
  'pd.valid': 'Hiệu lực',
  'pd.until': 'đến {d}',
  'pd.left': 'còn {n} ngày',
  'pd.leftToday': 'hết hạn hôm nay',
  'pd.expired': 'đã hết hạn',
  'pd.free': 'Free time',
  'pd.freeTip': 'Free time tại POD: {v}',
  'pd.cap': 'USD · {v}',
  'pd.capT1': 'giá bán bậc 1',
  'pd.capT2': 'giá bán bậc 2',
  'pd.capCost': 'giá mua',
  'pd.capFree': 'giá mua + margin',
  'pd.tt': 'T/T {n} ngày',
  'pd.direct': 'Đi thẳng',
  'pd.via': 'qua {v}',
  'pd.ttAria': '{a} → {b}, T/T {n} ngày, {m}',
  'pd.viaAria': 'chuyển tải {v}',
  'pd.directAria': 'đi thẳng',
  'pd.quoted': 'Đã báo',
  'pd.back': 'Về màn bắt đầu tra',
  'pd.condAria': 'Điều kiện tra',
  'pd.meta': '{n} hãng · {c}',
  'pd.compose': 'Soạn tin',
  'pd.quoteN': 'Tạo báo giá · {n}',
  'pd.quoteTip': 'Tick dòng giá rồi tạo báo giá',
  'pd.below': 'Dưới giá mua · cần duyệt',
});
addMessages('en', {
  'pd.pick': 'Add {v} to the quote',
  'pd.pickTip': 'Add this rate to the quote',
  'pd.open': 'Open {v} details: local charges, schedule, free time, rate history, quote this rate',
  'pd.openTip': 'Details · local charges, schedule, free time, rate history',
  'pd.carSvc': 'Carrier · Service',
  'pd.svcUnmapped': 'service not mapped',
  'pd.freqUnmapped': 'frequency not mapped',
  'pd.weekly': 'weekly · ETD {d}',
  'pd.valid': 'Valid',
  'pd.until': 'until {d}',
  'pd.left': '{n} days left',
  'pd.leftToday': 'expires today',
  'pd.expired': 'expired',
  'pd.free': 'Free time',
  'pd.freeTip': 'Free time at POD: {v}',
  'pd.cap': 'USD · {v}',
  'pd.capT1': 'tier 1 sell',
  'pd.capT2': 'tier 2 sell',
  'pd.capCost': 'buy rate',
  'pd.capFree': 'buy + margin',
  'pd.tt': 'T/T {n} days',
  'pd.direct': 'Direct',
  'pd.via': 'via {v}',
  'pd.ttAria': '{a} → {b}, T/T {n} days, {m}',
  'pd.viaAria': 'transhipment {v}',
  'pd.directAria': 'direct',
  'pd.quoted': 'Quoted',
  'pd.back': 'Back to search start',
  'pd.condAria': 'Search conditions',
  'pd.meta': '{n} carriers · {c}',
  'pd.compose': 'Compose message',
  'pd.quoteN': 'Create quote · {n}',
  'pd.quoteTip': 'Tick rate rows, then create a quote',
  'pd.below': 'Below buy · needs approval',
});
